<!--
 * @Author: Jason
 * @Date: 2019-10-15 17:32:50
 * @version: 
 * @LastEditors: Jason
 * @LastEditTime: 2019-10-29 16:34:35
 * @Descripttion: 
 -->
<template>
    <div>
        <v-head :isShowBack="$route.meta.isShowIcon" >我的订单</v-head>

        <div class="flex-btwn-aic order-classify" ref="test">
            <div class="order-classify-item" v-for="(item, index) in orderTypeList" :key="index" :class="{'active':orderType == item.oType}" @click="changeType(item.oType)">{{item.oName}}</div>
        </div>

        <div class="order-mt order-list" v-if="orderList&&orderList.length>0">
            <mt-loadmore :top-method="getOrderList" ref="loadmore">
               <div class="flex-btwn-aic order-item" v-for="(item, index) in orderList" :key="index">
                    <div class="order-item-btn" v-if="item.status == 1" @click="toShowQrcode(item)">查看二维码</div>
                    <img class="order-item-img" v-if="item.status == 6" src="../../assets/imgs/icon_ygq.png" alt="">
                    <div class="flex-jcc-aic flex-wrap order-item-left" :class="item.status == 1 ? 'use':'used'">
                        <div>
                            <div class="order-item-price">￥<span>{{item.amount || 1}}</span></div>
                            <div>洗车券</div>
                            <!-- <div>{{item.activityName}}</div> -->
                        </div>
                    </div>
                    <div class="flex-1 flex-wrap order-item-right">
                        <div class="order-item-info">支付金额：{{item.amount || 1}}元</div>
                        <div class="order-item-info">下单时间：{{item.createTime}}</div>
                        <div class="order-item-info" v-if="item.status == 5">使用时间：{{item.useTime}}</div>
                        <div class="order-item-info" v-else>有效期至：{{item.endTime}}</div>
                        <div class="order-item-info">电子消费码：{{item.orderId}}</div>
                    </div>
                </div>
                
            </mt-loadmore>
            <!-- <div class="flex-btwn-aic order-item">
                <div class="order-item-btn">查看二维码</div>
                <div class="flex-jcc-aic flex-wrap order-item-left use">
                    <div>
                        <div class="order-item-price">￥<span>10</span></div>
                        <div>洗车券</div>
                    </div>
                </div>
                <div class="flex-1 flex-wrap order-item-right">
                    <div class="order-item-info">支付金额：10元</div>
                    <div class="order-item-info">下单时间：2019-10-20</div>
                    <div class="order-item-info">有效期至：2017-08-01</div>
                    <div class="order-item-info">电子消费码：100GFTJ00</div>
                </div>
            </div>
            <div class="flex-btwn-aic order-item">
                <img class="order-item-img" src="../../assets/imgs/icon_ygq.png" alt="">
                <div class="flex-jcc-aic flex-wrap order-item-left used">
                    <div>
                        <div class="order-item-price">￥<span>10</span></div>
                        <div>洗车券</div>
                    </div>
                </div>
                <div class="flex-1 flex-wrap order-item-right">
                    <div class="order-item-info">支付金额：10元</div>
                    <div class="order-item-info">下单时间：2019-10-20</div>
                    <div class="order-item-info">有效期至：2017-08-01</div>
                    <div class="order-item-info">电子消费码：100GFTJ00</div>
                </div>
            </div> -->
        </div>
        <div v-else class="no-order-data">
            <img src="../../assets/imgs/icon_order_nodata.png" width="25%" alt="">
        </div>

        

        <transition name="fade">
            <div class="flex-jcc-aic mask" v-show="isShowQrCode" @click="isShowQrCode=false">
                <div class="mask-content" @click.stop>
                    <div class="el-icon-close qrcode-close-btn" @click="isShowQrCode=false"></div>
                    <div class="flex-jcc qrcode">
                        <img class="qrcode-logo" src="../../assets/imgs/suncar.png" alt="">
                        <qrcode-vue :size="qrcodeSize" :value="qrcodeValue" level="H"></qrcode-vue>
                    </div>
                    <!-- <div class="order-matrix">电子消费码：{{orderNum}}</div> -->
                
                    <div class="mask-content-tip">*请向商家出示此电子消费码或二维码享受服务 </div>
                    <div class="order-close-btn" @click="isShowQrCode=false">关闭</div>
                </div>
            </div>
        </transition>
        <transition name="fade">
            <div class="flex-jcc-aic mask" v-show="isShowMsg">
                <msg title="系统提示" :isShowOff='false' @confirm="confirmMsg()">
                    <div v-html="msgHtml"></div>
                </msg>
            </div>
        </transition>
        


    </div>
</template>
<script>
import QrcodeVue from 'qrcode.vue';
import vHead from "@/components/vHead.vue";
import msg from "@/components/messageBox.vue";
import { GetOrderList } from '@/api/order.js'
import { ls } from "@/assets/js/utils.js";
import { MessageBox } from 'mint-ui'
export default {
    components: {
        vHead,
        QrcodeVue,
        msg
    },

    data() {
        return {
            isShowMsg:false,
            qrcodeValue: '',
            qrcodeSize: 180,
            isShowQrCode:false,  
            orderType: 0,   //0.未使用  1已使用  
            orderTypeList:[
                {oType:0,oName:'未使用'},
                {oType:1,oName:'已使用'},
            ],
            orderList:[],
            msgHtml:'',
            
            
        };
    },
    mounted(){
        let _ = this
        document.body.style.backgroundColor = '#F4F5F7'
    },
    created(){
        let _ = this
        _.getOrderList()
        
    },
    methods:{
        
        getOrderList(){
            let _ = this
            let pars = {
                token:ls.getter('loginStatus'),
                // orderStatus:_.orderType
            }
            GetOrderList(pars).then(res=>{
                //   orderType: 0,   //0.未使用  1已使用  
                if(_.orderType == 0){
                    _.orderList = res.list.filter(i=>i.status == 1 || i.status == 6)
                }else if(_.orderType == 1){
                    _.orderList = res.list.filter(i=>i.status == 5)
                }
                
                _.$refs.loadmore.onTopLoaded();
            }).catch(err=>{
               if(err&&err.resultDes){
                    _.toast(err.resultDes)
                }
            })
        },
        changeType(val){
            let _ = this
            _.orderList = []
            _.orderType = val
            _.getOrderList()
        },
        toShowQrcode(i){
            let _ = this
            _.qrcodeValue = ''
            console.log('选取的item',i)
            if(i.status == 1){
                _.qrcodeValue = i.orderImg
                // _.orderNum = i.orderId
                _.isShowQrCode = true
            }
        },
        confirmMsg(){
            let _ = this
            _.getOrderList()
            _.isShowMsg = false
        },
    }
}
</script>
<style lang="scss" scoped>

.order-mt{
    margin-top: 24.5334vw;
}
.order-matrix{
    margin-top: 4vw;
    text-align: center;
    font-size: 4vw;
}
.order-close-btn{
  width: 100%;
  height: 12vw;
  line-height: 12vw;
  text-align: center;
  margin-top: 8vw;
  border-top: 1px solid #D9D9D9;
  color: #F85B46;
  font-size: 4.2667vw;
}
.order-classify{
  width: 100%;
  height: 12vw;
  background-color: #fff;
  position: fixed;
  left: 0;
  top: 12.2667vw;
  z-index: 10;
  .order-classify-item{
    width: 50%;
    height: 12vw;
    line-height: 12vw;
    font-size: 4vw;
    text-align: center;
    &.active{
      color: #16A085;
      border-bottom: 2px solid #16A085;
    }
  }
}
.no-order-data{
  text-align: center;
  padding-top: 64vw;
}
// 我的券码和我的订单
.order-list{
  padding: 4vw 2vw;
  width: 100%;
  .order-item{
    width: 100%;
    background-color: #fff;
    margin-bottom: 4vw;
    border-radius: 1.3333vw;
    overflow: hidden;
    height: 29.3333vw;
    position: relative;
    .order-item-btn{
      position: absolute;
      font-size: 3.2vw;
      top: 1vw;
      right: 2vw;
      padding: 1.3334vw 2vw;
      border: 1px solid #16A085;
      color: #16A085;
      border-radius: 2vw;
    }
    .order-item-img{
      position: absolute;
      width: 10vw;
      height: 10vw;
      top: 2vw;
      right: 2vw;
    }
    .order-item-left{
      width: 29.3333vw;
      height: 100%;
      position: relative;
      color: #fff;
      text-align: center;
      .order-item-price{
        width: 100%;;
        font-size: 4vw;
        span{
          font-size: 9.0667vw;
        }
      }
      &.use{
        background: url('./../../assets/imgs/icon_order_bg_use.png') no-repeat 100% 100%;
        background-size: 100% 100%;
        // background-color: #F43F27;
      }
      &.used{
        background: url('./../../assets/imgs/icon_order_bg_used.png') no-repeat 100% 100%;
        background-size: 100% 100%;
        // background-color: #E4E4E4;
      }
    }
    .order-item-right{
      padding: 3.2vw 2vw;
      font-size: 3.6vw;
      .order-item-info{
        width: 100%;
        line-height: 6.4vw;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
  
}
</style>


